import { AgentInterface } from '../Agent/Agent.Model'

export interface UserInterface {
  id: string
  thirdPartyId?: string
  name: string
  botId: string
  variables?: UserVariables
  lastInteraction?: Date
  createdAt?: Date
  takenOver?: boolean
  takeoverAgent?: AgentInterface
  takeoverChannel?: UserTakeoverChannel
  token?: string
  archived: boolean
  address?: UserAddress
  lastUserInput?: string
  isBlocked?: boolean
}
interface UserVariables {
  [key: string]: string
}
export enum UserTakeoverChannel {
  SMS = 'SMS',
  Web = 'Web'
}

export interface UserAddress {
  origin?: string
  port?: string
  protocol?: string
  hostname?: string
  pathname?: string
  hash?: string
}
